<template>
  <div>
    <SideBarFilter
      :filter="form"
      ref="sidebarSlot"
      placeholder="กำหนดที่ว่างพิเศษตามวัน"
      :hideStatusFilter="false"
      :hideSearchBar="true"
      title="กำหนดที่ว่างพิเศษตามวัน"
      textSubmit="บันทึก"
      hideFilter
      handleSideBar
      @searchAll="handleSave"
      :isLoading="isLoading"
      @clearLoading="isLoading = false"
      @clearForm="clearForm"
    >
      <template v-slot:filter-option>
        <div class="my-3">
          <div class="font-weight-bold mb-1">
            วัน
            <span class="text-error">*</span>
          </div>
          <div :class="['input-container', { error: $v.form.date.$error }]">
            <datetime
              v-model="form.date"
              :input-style="styleDatetime"
              format="dd/MM/yyyy"
              value-zone="local"
              placeholder="กรุณาเลือกวัน"
              ref="date"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.date.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
          <p class="m-0 text-error" v-if="$v.form.date.$error">กรุณาเลือกวัน</p>
        </div>
        <div class="my-3">
          <div class="label mb-2">
            เวลาเริ่มต้น
            <span class="text-error">*</span>
          </div>
          <div
            :class="['input-container', { error: $v.form.timeStart.$error }]"
          >
            <datetime
              v-model="form.timeStart"
              :input-style="styleDatetime"
              value-zone="local"
              placeholder="กรุณาเลือกเวลาเริ่มต้น"
              ref="timeStart"
              type="time"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.timeStart.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
          <p class="m-0 text-error" v-if="$v.form.timeStart.$error">
            กรุณาเลือกเวลาเริ่มต้น
          </p>
        </div>
        <div class="my-3">
          <div class="font-weight-bold mb-1">เวลาสิ้นสุด</div>
          <div :class="['input-container', { error: $v.form.timeEnd.$error }]">
            <datetime
              v-model="form.timeEnd"
              :input-style="styleDatetime"
              type="time"
              value-zone="local"
              placeholder="กรุณาเลือกเวลาสิ้นสุด"
              ref="timeEnd"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.timeEnd.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
          <p class="m-0 text-error" v-if="$v.form.timeEnd.$error">
            กรุณาเลือกเวลาสิ้นสุด
          </p>
        </div>
        <div class="my-3">
          <InputText
            v-model="form.slotQuantity"
            class="input"
            textFloat="จำนวนที่ว่าง"
            placeholder="จำนวนที่ว่าง"
            type="number"
            name="slotQuantity"
            isRequired
            :v="$v.form.slotQuantity"
            :isValidate="$v.form.slotQuantity.$error"
          />
        </div>
        <div class="my-3">
          <div class="font-weight-bold mb-1">สถานะ</div>
          <b-form-checkbox
            v-model="form.isActive"
            switch
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </div>
      </template>
    </SideBarFilter>
    <ModalAlertText
      key="ExtradateFormElert"
      :textModal="textModal"
      :arrModal="arrStatus"
      :btnText="isOverlap ? 'เวลาที่ซ้อนทับกัน' : undefined"
      id="modal-alert-text-2"
      @clearArrModal="closeModalAlertText"
    />
  </div>
</template>

<script>
import UploadFile from "@/components/inputs/UploadFile";
import ModalAlertText from "@/components/modal/ModalAlertText.vue";
import InputText from "@/components/inputs/InputText";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
export default {
  name: "ExtradateForm",
  components: {
    UploadFile,
    ModalAlertText,
    InputText,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    id: {
      required: true,
      type: Number,
    },
    data: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        id: 0,
        date: "",
        timeStart: "",
        timeEnd: "",
        slotQuantity: null,
        isActive: false,
        eventSlotGroupId: 1,
      },

      isLoading: false,

      // state modal
      textModal: "",
      arrStatus: [],

      styleDatetime: {
        width: "100%",
        border: "none",
      },

      isOverlap: false,
    };
  },
  validations() {
    return {
      form: {
        date: { required },
        timeStart: { required },
        timeEnd: { required },
        slotQuantity: { required },
      },
    };
  },
  watch: {
    visible(val) {
      if (val === true) {
        this.$refs.sidebarSlot.show();
      } else {
        this.$refs.sidebarSlot.hide();
      }
    },
    data: {
      handler(val) {
        this.$v.$reset();
        this.form = val
          ? {
              ...val,
            }
          : {
              id: 0,
              date: "",
              timeStart: "",
              timeEnd: "",
              slotQuantity: 0,
              isActive: false,
              eventSlotGroupId: this.$route.query.type,
            };
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  computed: {},
  methods: {
    isTimeFormat(text) {
      const timeRegex = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
      return timeRegex.test(text);
    },

    handleSave() {
      this.$v.form.$touch();

      if (this.$v.form.$error) return;
      this.isLoading = true;

      this.$services.slotgroup
        .saveExtraDate({
          ...this.form,
          date: this.$moment(this.form.date).format("YYYY-MM-DD"),
          timeStart: this.isTimeFormat(this.form.timeStart)
            ? this.form.timeStart
            : this.$moment(this.form.timeStart).format("HH:mm:ss"),
          timeEnd: this.isTimeFormat(this.form.timeEnd)
            ? this.form.timeEnd
            : this.$moment(this.form.timeEnd).format("HH:mm:ss"),

          eventSlotGroupId: this.$route.params.id
            ? parseInt(this.$route.params.id)
            : undefined,
        })
        .then(async (res) => {
          const text = await res.message;
          this.openModalAlertText(text);
          if (res.result == 1) {
            this.clearForm();
            this.$emit("fetchTable");
          } else {
            this.isOverlap = res.detail?.isOverlap;
          }
        });
    },

    onChangeStatus(item) {
      this.$services.slotgroup
        .changeStatus({
          id: item.id,
          isActive: item.isActive,
        })
        .then(async (res) => {
          const text = await res.message;
          this.openModalAlertText(text);
          if (res.result == 1) {
            this.clearForm();
            this.$emit("fetchTable");
          } else {
            this.isOverlap = res.detail?.isOverlap;
          }
        });
    },

    clearForm() {
      this.$emit("hideForm");
      this.isLoading = false;
      this.isOverlap = false;
    },
    openModalAlertText(text) {
      this.textModal = text;
      this.$bvModal.show("modal-alert-text-2");
    },
    closeModalAlertText() {
      if (this.isOverlap) {
        this.$emit("handleOverlap", this.form);
      }
      this.clearForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.render-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 200px;
  border: 1px dashed gray;
}
.list-lang {
  display: flex;
  justify-content: right;

  .box-lang {
    padding: 5px 10px;
    margin-right: 5px;
    border: 1px solid black;
    cursor: pointer;

    &.active {
      background: var(--secondary-color);
      color: white;
    }
  }
}
</style>
